<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="objectId()"
  [cdkConnectedOverlayOpen]="userService.user().showTutorials[tutorialId()]"
  [cdkConnectedOverlayPositions]="tutorialPositions">

  <div class="info-bubble">
    <button matIconButton class="close-btn" (click)="removeTutorial(tutorialId())">
      <mat-icon>close</mat-icon>
    </button>

    <div class="talking">{{tutorialText()}}</div>
  </div>

</ng-template>